import Cookies from 'js-cookie'

export const TokenKey = 'doc_tracking_token'

export function getToken() {
  const token = Cookies.get(TokenKey)
  return token && token !== 'undefined' ? token : null
}

export function setToken(token) {
  return Cookies.set(TokenKey, token || '')
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
